import React, { useState } from 'react'
import { Button, Col, Drawer, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { assetHistotry } from '../../../redux/actions/addDurableArticles'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import { budgetFormat } from '../../../utils/formatterUtil'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import AddAssetCountingTable from './AddAssetCountingTable'

export default function AddAssetCountingSupplyOfficerWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowHistory, setIsShowHistory] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [historySchema, setHistorySchema] = useState()

  const onViewHistory = async (id) => {
    setIsShowHistory(true)
    setIsLoading(true)
    startLoading()

    try {
      var response = await assetHistotry(id)
      if (response.model) {
        setHistorySchema(response.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
        setIsShowHistory(false)
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
      setIsShowHistory(false)
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <AddAssetCountingTable
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          schema={formSchema?.form}
          isViewMode={!formSchema?.form?.isEnableEdit}
          isSupplyOfficer={true}
          disabled={!formSchema?.disabled}
        />
      </Panel>
    </>
  )
}
